module.exports = __webpack_public_path__ + "1b2f8edfb179d07eff887e6b85d213da.png";